const getModuleState = (state) => state.users;

export const getUsers = (state) => getModuleState(state).users;